import { apiCall, filterParams } from '../helpers/axios';

class PersonService {

	static getAll(params, cancelToken) {
		return apiCall().get('/persons', { params: params, cancelToken: cancelToken })
			.then(response => response.data)
	}

	static getOne(personId) {
		return apiCall().get(`/persons/${personId}`)
			.then(response => response.data);
	}

	static create(person) {
		return apiCall().post(`/persons`, person)
			.then(response => response.data);
	}

	static update(personId, data) {
		return apiCall().put(`/persons/${personId}`, data)
			.then(response => response.data);
	}

	static delete(personId) {
		return apiCall().delete(`/persons/${personId}`)
			.then(response => response.data);
	}

	static getAuctionStats(auctionId, personId) {
		return apiCall().get(`/auctions/${auctionId}/person/${personId}`)
			.then(response => response.data);
	}

	static getSellerCost(auctionId, personId) {
		return apiCall().get(`/auctions/${auctionId}/seller/${personId}/costs`)
			.then(response => response.data);
	}

	static updateSellerCost(auctionId, personId, data) {
		return apiCall().put(`/auctions/${auctionId}/seller/${personId}/costs`, data)
			.then(response => response.data);
	}

	static getCountryList() {
		return apiCall().get('/country_list')
			.then(response => response.data);
	}
}

export default PersonService


// WEBPACK FOOTER //
// ./src/services/person-service.js